if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        // if(this.submitButtonText) this.submitButtonText = this.submitButton.querySelector('span');
        if(this.submitButton) this.submitButtonText = this.submitButton.querySelector('span');
        if (this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
         
        const formData = new FormData(this.form);
        // Optional notes (e.g. Additional Info box) shouldn't create an empty line item property.
        document.querySelectorAll(`[form="${this.form.id}"][data-optional-property]`).forEach((field) => {
          if (field.value.trim() === '') formData.delete(field.name);
        });
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        function generateRandomId() {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            let result = '';
            for (let i = 0; i < 7; i++) {
                const randomIndex = Math.floor(Math.random() * characters.length);
                result += characters[randomIndex];
            }
            return `${result}`;
        }

        var SwymGrBundleID = '';
        if (document.querySelector('.SwymGrAddOnProducts')) {
          SwymGrBundleID = generateRandomId();  
        }
        // console.log("ITG00001 - ", SwymGrBundleID );
        const SwymGrAddOnProducts = document.querySelectorAll('.SwymGrAddOnProducts');
        let hasBundleAddOns = false;
        if (SwymGrAddOnProducts) {
          SwymGrAddOnProducts.forEach((product, index) => {
            const SwymGrAddOnVariantId = product.value;
            if (SwymGrAddOnVariantId.trim() === '') {
              // return;
            } else {
              const SwymGrAddOnQty = document.querySelector('.itg_ctm_quantity quantity-input.quantity input[name="quantity"]').value;   
              // console.log(SwymGrAddOnVariantId + ' -- ' + SwymGrAddOnQty);
              formData.set(`items[${index}][id]`, SwymGrAddOnVariantId);
              formData.set(`items[${index}][quantity]`, SwymGrAddOnQty);
              formData.set(`items[${index}][properties][BundleId]`, SwymGrBundleID);
              hasBundleAddOns = true;
            }
          });
        }
        // Tag the head too, so the cart groups it with its add-ons and bundle-guard.js
        // doesn't treat those add-ons as orphaned.
        if (hasBundleAddOns) {
          formData.set('properties[BundleId]', SwymGrBundleID);
          formData.set('properties[Main]', 'product');
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            fetch('/cart.js')
              .then(r => r.json())
              .then(cart => {
                //console.log(cart.item_count,'dd')
                const cardCount = document.querySelector('.header__icons .cart-count-bubble');
                // if(cardCount && cart.item_count == 0){
                //   cardCount.classList.add('is-empty');
                // }else{
                //   cardCount.classList.remove('is-empty');
                // } 
                if (cardCount) cardCount.classList.toggle('is-empty', cart.item_count == 0);              
              });
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          if(this.submitButton) this.submitButton.setAttribute('disabled', 'disabled');
          // if (text) this.submitButtonText.textContent = text;
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;  
        } else {
          if(this.submitButton) this.submitButton.removeAttribute('disabled');
          // if(this.submitButton) this.submitButtonText.textContent = window.variantStrings.addToCart;
          if(this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart; 
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
